import { RootState } from "@/store/store";
import { ModuleTree } from "vuex";
import { citationActions } from "./citation.actions";
import { citationMutations } from "./citation.mutations";
import { citationState } from "./citation.state";

export default {
    namespaced: true,
    state: citationState,
    actions: citationActions,
    mutations: citationMutations,
} as unknown as ModuleTree<RootState>;